import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type TemplatePreviewFragment = (
  { __typename: 'Board' }
  & Pick<Types.Board, 'id' | 'name' | 'shortLink'>
);

export const TemplatePreviewFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TemplatePreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortLink' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseTemplatePreviewFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      TemplatePreviewFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseTemplatePreviewFragmentResult
  extends Omit<Apollo.UseFragmentResult<TemplatePreviewFragment>, 'data'> {
  data?: TemplatePreviewFragment;
}

export const useTemplatePreviewFragment = ({
  from,
  returnPartialData,
  ...options
}: UseTemplatePreviewFragmentOptions): UseTemplatePreviewFragmentResult => {
  const result = Apollo.useFragment<TemplatePreviewFragment>({
    ...options,
    fragment: TemplatePreviewFragmentDoc,
    fragmentName: 'TemplatePreview',
    from: {
      __typename: 'Board',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as TemplatePreviewFragment };
};
